import React, { Component } from 'react';
import _ from 'lodash';
import { connect } from 'react-redux';
import { Helmet } from 'react-helmet-async';
import { pageTitle } from '../../../util/pageTitles';

import NoData from '../../../components/NoData/NoData';
import CardPlaceholder from '../../../components/CardPlaceholder';
import { setChart, saveConfig, updateBlockersChart, updateBreakdown } from '../../../components/Filter/FilterActions';
import { setPageName } from './../../App/AppActions';
import { getData } from '../CTBActions';

import Filter from '../../../components/Filter/Filter';
import { DatePicker, Options } from '../../../components/Filter/components';
import DetailsAccordion from '../../../components/DetailsAccordion/DetailsAccordion';
import BlockersStats from '../../Common/components/BlockersStats';

import { 
  trackTeamDashboardView, 
  trackChartPointDetailsView,
  trackHowToOpened 
} from '../../../util/mixpanel';

import CTBChart from '../components/CTBChart';
import CTBreakdown from '../components/CTBreakdown';

import './../CTB.scss';
import ChartDownloadMenu from '../../../components/ChartDownloadMenu';

export class CTB extends Component {
  constructor(props) {
    super(props);

    this.state = {
      selectedPoint: {}
    };

    props.dispatch(setPageName('Cycle time breakdown'));
  }

  componentDidMount() {
    if (this.props.dashboard && this.props.dashboard._id && this.props.dataIsLoading === false) {
      this.props.setChart('ctb');

      trackTeamDashboardView('ctb');
    }
  }

  componentDidUpdate(prevProps) {
    if (
      (prevProps.dataHash != this.props.dataHash || prevProps.hash != this.props.hash) &&
      this.props.dataIsLoading === false
    ) {
      this.handleChange();
    }
  }

  handleChange(force) {
    if (force || !this.props.dataIsLoading) {
      this.setState({
        selectedPoint: {}
      });
      this.props.getData();
    }
  }

  handlePointClick = point => {
    this.setState({
      selectedPoint: point
    });

    trackChartPointDetailsView('ctb', true);
  };

  trackHowToCTBOpen() {
    trackHowToOpened('ctb');
  }

  getBlockersFlags() {
    const { app, dashboard } = this.props;
    const showBlockers = app === 'trello' || app === 'azure' || app === 'jira' || (app === 'file' && !dashboard.isAzure);
    const blockersDisabled =
      dashboard.application === 'jira' && dashboard.isBusiness && !dashboard.selectedBlockedFlag ||
      dashboard.application === 'trello' &&  !dashboard.selectedBlockedFlag || 
      dashboard.application === 'azure' && !dashboard.selectedBlockedFlag;
    return { showBlockers, blockersDisabled };
  }

  handleCloseBlockers = () => {
    this.props.closeBlockers();
    this.props.saveConfig();
  };

  handleCloseBreakdown = () => {
    this.props.closeBreakdown();
    this.props.saveConfig();
  };

  render() {
    const { showBlockers, blockersDisabled } = this.getBlockersFlags();   
    const blockersStats = showBlockers && this.props.data && this.props.data.blockersStats;

    const tooltip = (
      <div className="more_info_tooltip">
        <div className="more_info-inner">
          <h4>Cycle Time Breakdown Chart</h4>
          <p>Each stacked column shows cycle time for a period or item, split across workflow states, including blocked time in each state. Labels show each segment's percentage share.</p>
          <p><b>Look for:</b> large state segments, which can indicate where work spends most of its cycle time.</p>
          <a
          href={`https://getnave.com/cycle-time-breakdown-chart`}
          target="_blank"
          onClick={this.trackHowToCTBOpen}
          onAuxClick={this.trackHowToCTBOpen} 
          className='more_info-link'
          >
            Learn more →
        </a>
        </div>
      </div>
    );

    const totalItems = !this.props.data ? 0 : _.reduce(this.props.data.cycleTimes, (p, c) => {
      return p + (c.data && c.data.length || 0);
    }, 0);

    return (
      <div className="content-wrap">
        <Helmet>
          <title>{pageTitle(`Cycle Time Breakdown Chart${this.props.dashboard ? ' | ' + this.props.dashboard.name : ''}`)}</title>
        </Helmet>
        <Filter totalItems={totalItems} timeunit dateformat enableMarkBlocked enableBreakdownBy disable={[]} />
        <div className="chart_box_view">
          <div className="dashboard_head">
            <div className="flex-layout">
              <h1>
                Cycle Time Breakdown Chart
              </h1>
              <div className="more_info_content">
                <span className="more_info"></span>
                {tooltip}
              </div>
            </div>
            <div className="button_tools">
              <Options
                showBreakdown
                showBlockers={showBlockers}
                blockersDisabled={blockersDisabled}
              />
              <DatePicker />
            </div>
          </div>
          <div>
            <div className="dashboard_details">
              {/* the card shows only with its toolbar button: offered for the app and enabled by a blocked flag */}
              {this.props.blockersChart && showBlockers && !blockersDisabled && (blockersStats ? (
                <BlockersStats id="stats" data={blockersStats} focusable />
              ) : (
                <CardPlaceholder title="Blockers" shape="table" loading={this.props.isLoading} onClose={this.handleCloseBlockers} />
              ))}
              {this.props.breakdown && (this.props.data.cycleTimes && !!this.props.data.cycleTimes.length ? (
                <CTBreakdown id="ctbreakdown" data={this.props.data.cycleTimes} widget="ctb" />
              ) : (
                <CardPlaceholder title="Cycle Time Breakdown" shape={this.props.breakdownType === 'pie' ? 'pie' : 'columns'} loading={this.props.isLoading} onClose={this.handleCloseBreakdown} />
              ))}
            </div>
            <div className="chart_row">
              <div className="diagram_details">
                <ChartDownloadMenu chartId="CTB" />
                <CTBChart
                  id="CTB"
                  data={this.props.data.breakdown}
                  throughput={this.props.data.throughput}
                  onPointClick={this.handlePointClick}
                  blockedTime={this.props.blockedTime}
                />
                <NoData
                  show={this.props.data.breakdown && !this.props.data.breakdown.length}
                  loading={this.props.isLoading}
                />
              </div>
              <DetailsAccordion
                dateLabel={this.props.timeUnit === 'cards' ? 'Name' : ''}
                valueLabel="Cycle time"
                value2Label="Throughput"
                chart="ctb"
                id="details-accordion"
                data={this.state.selectedPoint}
                blockedTime={this.props.blockedTime}
                blockers={this.props.blockers}
              />
            </div>
          </div>
        </div>
      </div>
    );
  }
}

const mapDispatchToProps = dispatch => {
  return {
    setChart: name => dispatch(setChart(name)),
    getData: () => dispatch(getData()),
    closeBlockers: () => dispatch(updateBlockersChart(false, 'ctb')),
    closeBreakdown: () => dispatch(updateBreakdown(false, 'ctb')),
    saveConfig: () => dispatch(saveConfig())
  };
};

const mapStateToProps = state => {
  return {
    breakdownType: state.filters.ctb.breakdownType,
    app: state.app.app,
    hash: state.filters.ctb.hash,
    breakdown: state.filters.ctb.breakdown,
    timeUnit: state.filters.ctb.timeUnit,
    blockedTime: state.filters.ctb.blockedTime,
    breakdownBy: state.filters.ctb.breakdownBy,
    blockersChart: state.filters.ctb.blockersChart,
    blockers: state.filters.ctb.blockers,
    data: state.ctb.data,
    isLoading: state.ctb.isLoading,
    dashboard: state.dashboards.selected,
    dataIsLoading: state.app.isLoading,
    dataHash: state.app.dataHash
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(CTB);
